// third-party
import { createSlice } from "@reduxjs/toolkit";


type UserState = {
  error: string | null;
  user: { name: string; profileImageUrl: string };
};

const initialState: UserState = {
  error: null,
  user: {
    name: "",
    profileImageUrl: "",
  },
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    clearUser: (state) => {
      state.user = initialState.user;
    },
  },
});

// Reducer
export default slice.reducer;

export const { clearUser, setUser, updateUser } = slice.actions;
